import { AuthRouter } from './authRouter'
import { BaseRouter } from './BaseRouter'

const Router = () => {
  return (
    <AuthRouter>
      <BaseRouter />
    </AuthRouter>
  )
}

export { Router }